/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsPlatformBranchCreateInput } from "../../entities/models/PlatformBranchCreateInput";
import { z } from "zod/v4";

export const modelsPlatformBranchCreateInputSchema = z.object({
    "address": z.optional(z.string()),
"company_id": z.int(),
"name": z.string(),
"phone": z.optional(z.string()),
"timezone": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsPlatformBranchCreateInput>